import Api from '@utils/api';
import { Carreras } from '@constants/urls';

export const state = {
	carreras: [],
	carrera: {},
	filtro: '',
	loading: false,
	loading_action: false
};

export const getters = {
	getCarreras(state) {
		return state.carreras;
	},
	getCarrera(state) {
		return state.carrera;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	}
};

export const mutations = {
	SET_CARRERAS(state, newValue) {
		state.carreras = newValue;
	},
	SET_CARRERA(state, newValue) {
		state.carrera = newValue;
	},
	SET_FILTRO(state, newValue) {
		state.filtro = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	}
};

export const actions = {
	inicializar({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Carreras.LISTAR)
			.then((response) => {
				// console.log("tonio")
				// console.log(response)
				commit('SET_CARRERAS', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	establecerCarrera({ commit }, carrera) {
		commit('SET_CARRERA', carrera);
	},
	establecerFiltro({ commit }, { filtro }) {
		commit('SET_FILTRO', filtro);
	},
	subirArchivoCsv({ commit }, { archivos, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Carreras.CREAR, archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodos({ commit }, { onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Carreras.ELIMINAR_TODOS)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	}
};
